__turbopack_context__.v({
  "accordionBody": "Accordion-module-scss-module__KIFV9q__accordionBody",
  "accordionTitle": "Accordion-module-scss-module__KIFV9q__accordionTitle",
  "accordionitem": "Accordion-module-scss-module__KIFV9q__accordionitem",
  "opened": "Accordion-module-scss-module__KIFV9q__opened",
});
